import { createAsyncThunk } from '@reduxjs/toolkit';
import { downloadFormsByTypeService } from 'scenes/ProjectForms/utils/downloadFormsService';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';

export const downloadFormsByType = createAsyncThunk(
    'projectForm/downloadFormsByType',
    async (args, { getState }) => {
        const { formType, formLabels, fromDate, toDate } = args;

        const selectedProjectId = selectSelectedProjectId(getState());

        const response = await downloadFormsByTypeService(selectedProjectId, formType, formLabels, fromDate, toDate);
        return { response };
    }
);
